import { useState, useRef } from "react";
import { loginWithEmail, checkAdminStatus, logFailedLoginAlert } from "../services/authService";

const ALERT_THRESHOLD = 3;

export function useAuthLogic(onSignIn) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const failedCountRef = useRef(0);

  const handleFailedAttempt = async (userEmail) => {
    failedCountRef.current += 1;
    if (failedCountRef.current % ALERT_THRESHOLD === 0) {
      await logFailedLoginAlert(userEmail, failedCountRef.current);
    }
  };

  const handleSignInWithEmail = async () => {
    try {
      const user = await loginWithEmail(email, password);
      setError("");
      failedCountRef.current = 0;

      const isAdmin = await checkAdminStatus(user.email);
      onSignIn(user, isAdmin);
    } catch (error_) {
      console.error("Authentication failed:", error_);
      setError("Invalid credentials. Please try again.");
      await handleFailedAttempt(email);
    }
  };

  return {
    email,
    setEmail,
    password,
    setPassword,
    error,
    handleSignInWithEmail
  };
}
